import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FundamentCommonModule } from '../fundament-common.module';
import { IconComponent } from './icon/icon.component';
import { ImageComponent } from './image/image.component';
import { LogoComponent } from './logo/logo.component';

@NgModule({
  imports: [AngularSvgIconModule, CommonModule, FundamentCommonModule],
  declarations: [ImageComponent, IconComponent, LogoComponent],
  exports: [ImageComponent, IconComponent, LogoComponent],
})
export class FoundationModule {}
